export default __webpack_public_path__ + "static/assets/efb7ead273e261cb55f20d7c1890432e.png";